<template>
    <v-app class="vapp">
        <div
            id="reservations_intro"
            name="bookingModalName"
            :style="popupStyle"
            class="popup ppv2-bg-white dark:ppv2-bg-dark"
            v-if="bookingModal"
        >
            <div class="row b-modal-header">
                <div class="col-11 ppv2-text-black">
                    {{ $t('planning_v3.reservations') }}
                    <svg
                        class="ms-1"
                        fill="#7D2DBD"
                        height="25"
                        width="25"
                        viewBox="0 0 32 32"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        @click="() => startIntro()"
                    >
                        <path
                            d="M11.188 4.781c6.188 0 11.219 5.031 11.219 11.219s-5.031 11.188-11.219 11.188-11.188-5-11.188-11.188 5-11.219 11.188-11.219zM11.063 8.906c-0.313 0.375-0.469 0.813-0.469 1.281 0 0.375 0.125 0.688 0.313 0.906 0.219 0.219 0.531 0.344 0.844 0.344 0.438 0 0.844-0.188 1.156-0.563 0.281-0.344 0.438-0.844 0.438-1.375 0-0.313-0.094-0.594-0.313-0.813s-0.531-0.344-0.844-0.344c-0.406 0-0.813 0.188-1.125 0.563zM8.219 15.375l0.375 0.406c0.281-0.313 0.563-0.563 0.75-0.719 0.188-0.125 0.344-0.188 0.469-0.188 0.094 0 0.188 0.031 0.25 0.094 0.031 0.094 0.063 0.188 0.063 0.344 0 0.781-0.094 1.281-0.5 3.156s-0.625 3.25-0.625 4.156c0 0.344 0.063 0.594 0.188 0.75 0.094 0.156 0.281 0.281 0.531 0.281 0.406 0 1-0.313 1.688-0.844 0.688-0.563 1.375-1.344 2.125-2.344l-0.406-0.344c-0.25 0.313-0.5 0.531-0.688 0.688-0.188 0.125-0.344 0.25-0.469 0.25-0.094 0-0.188-0.094-0.25-0.156-0.031-0.094-0.063-0.219-0.063-0.406 0-0.125 0.031-0.531 0.156-1.25 0.094-0.719 0.063-0.719 0.25-1.781 0.031-0.313 0.125-0.75 0.219-1.281 0.25-1.594 0.406-2.563 0.406-2.875 0-0.281-0.094-0.531-0.188-0.688-0.125-0.156-0.313-0.219-0.531-0.219-0.375 0-0.875 0.281-1.563 0.781-0.688 0.531-1.375 1.25-2.188 2.188z"
                        ></path>
                    </svg>
                </div>
                <div class="col-1 px-1" @click="bookingModal = false">
                    <span class="close-btn ppv2-bg-black ppv2-bg-opacity-[5%]"
                        ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M10.9512 1.05029L1.05168 10.9498"
                                stroke="#94A3B8"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M1.05078 1.05029L10.9503 10.9498"
                                stroke="#94A3B8"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </span>
                </div>
            </div>
            <div class="cmd-info">
                <div
                    class="w-100 rounded-12 d-flex justify-content-center bg-outline-warning mb-3"
                    v-if="selectedContext.event.data.info.enableMixing == 0"
                >
                    <h5 class="text-outline-warning mb-0 py-3">{{ $t('planning_v3.mixing_disabled_warning') }}</h5>
                </div>
                <div class="bloc border-solid-1-gs w-100 rounded-12">
                    <div class="b-info b-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M11.0938 13.75C11.0938 13.8743 11.0444 13.9935 10.9565 14.0815C10.8686 14.1694 10.7493 14.2188 10.625 14.2188C10.3349 14.2188 10.0567 14.1035 9.85161 13.8984C9.64649 13.6933 9.53125 13.4151 9.53125 13.125V10C9.53125 9.95856 9.51479 9.91882 9.48549 9.88951C9.45619 9.86021 9.41644 9.84375 9.375 9.84375C9.25068 9.84375 9.13146 9.79436 9.04355 9.70646C8.95564 9.61855 8.90625 9.49932 8.90625 9.375C8.90625 9.25068 8.95564 9.13145 9.04355 9.04354C9.13146 8.95564 9.25068 8.90625 9.375 8.90625C9.66508 8.90625 9.94328 9.02148 10.1484 9.2266C10.3535 9.43172 10.4688 9.70992 10.4688 10V13.125C10.4688 13.1664 10.4852 13.2062 10.5145 13.2355C10.5438 13.2648 10.5836 13.2812 10.625 13.2812C10.7493 13.2812 10.8686 13.3306 10.9565 13.4185C11.0444 13.5065 11.0938 13.6257 11.0938 13.75ZM9.6875 7.34375C9.84202 7.34375 9.99307 7.29793 10.1215 7.21209C10.25 7.12624 10.3502 7.00423 10.4093 6.86147C10.4684 6.71872 10.4839 6.56163 10.4537 6.41009C10.4236 6.25854 10.3492 6.11933 10.2399 6.01007C10.1307 5.90081 9.99147 5.82641 9.83992 5.79626C9.68837 5.76612 9.53129 5.78159 9.38853 5.84072C9.24578 5.89985 9.12376 5.99998 9.03792 6.12846C8.95207 6.25694 8.90625 6.40798 8.90625 6.5625C8.90625 6.7697 8.98856 6.96841 9.13508 7.11493C9.28159 7.26144 9.4803 7.34375 9.6875 7.34375ZM17.9688 10C17.9688 11.5761 17.5014 13.1167 16.6258 14.4272C15.7502 15.7377 14.5056 16.759 13.0495 17.3622C11.5934 17.9653 9.99116 18.1231 8.44538 17.8156C6.89959 17.5082 5.4797 16.7492 4.36525 15.6348C3.2508 14.5203 2.49185 13.1004 2.18437 11.5546C1.87689 10.0088 2.0347 8.40659 2.63784 6.95049C3.24097 5.49439 4.26235 4.24984 5.5728 3.37423C6.88326 2.49861 8.42393 2.03125 10 2.03125C12.1127 2.03373 14.1381 2.87409 15.632 4.36798C17.1259 5.86188 17.9663 7.88732 17.9688 10ZM17.0313 10C17.0313 8.60935 16.6189 7.24993 15.8463 6.09365C15.0737 4.93736 13.9755 4.03615 12.6907 3.50397C11.406 2.97179 9.9922 2.83255 8.62827 3.10385C7.26435 3.37516 6.0115 4.04482 5.02816 5.02816C4.04482 6.01149 3.37516 7.26434 3.10386 8.62827C2.83255 9.9922 2.9718 11.406 3.50398 12.6907C4.03615 13.9755 4.93737 15.0737 6.09365 15.8463C7.24993 16.6189 8.60935 17.0312 10 17.0312C11.8642 17.0292 13.6514 16.2877 14.9696 14.9696C16.2877 13.6514 17.0292 11.8642 17.0313 10Z"
                                fill="#46D5B3"
                            />
                        </svg>
                        <!--Devis:-->
                    </div>
                    <div class="b-info b-title fw-light">
                        {{
                            (
                                getTotalCMDDetails.currentPrice -
                                (getTotalCMDDetails.totalPrice - getTotalCMDDetails.totalRemise)
                            ).toFixed(2)
                        }}
                        /
                        <span class="original-price" v-if="getTotalCMDDetails.totalRemise > 0">
                            ({{ getTotalCMDDetails.totalPrice }} {{ $symbolCurrency }} )</span
                        >
                        {{ getTotalCMDDetails.totalPrice - getTotalCMDDetails.totalRemise }} {{ $symbolCurrency }}
                    </div>
                    <div class="b-info b-title fw-light">
                        {{
                            getPercentage(
                                getTotalCMDDetails.currentPrice,
                                getTotalCMDDetails.totalPrice - getTotalCMDDetails.totalRemise
                            )
                        }}
                        %
                    </div>
                </div>
                <div class="bloc border-solid-1-gs w-100 rounded-12">
                    <div class="b-info b-title">{{ $t('planning_v3.capacity') }}</div>
                    <div class="b-info b-title fw-light">
                        <span>&#128101;</span>
                        {{ getTotalCMDDetails.currentTicketsNbr }}
                        <span
                            class="b-title fw-light"
                            v-if="!['simpleticket'].includes(getPrestationTypeSlug(selectedContext.event.data.prestation))"
                            >/
                            {{ getTotalCMDDetails.totalTicketsNbr }}
                        </span>
                        {{ $t('planning_v3.listing.persons') }}
                    </div>
                    <div
                        class="b-info b-title fw-light"
                        v-if="getPrestationTypeSlug(selectedContext.event.data.prestation) != 'simpleticket'"
                    >
                        {{ getPercentage(getTotalCMDDetails.currentTicketsNbr, getTotalCMDDetails.totalTicketsNbr) }} %
                    </div>
                </div>

                <v-text-field
                    clearable
                    single-line
                    hide-details
                    color="#505050"
                    :label="$t('common.search')"
                    class="res-search form-control py-1 mb-3"
                    style="font-size: 12px"
                >
                    <template #prepend-inner>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            style="margin-top: -3px"
                        >
                            <path
                                d="M8.75002 15.8334C12.6621 15.8334 15.8334 12.6622 15.8334 8.75008C15.8334 4.838 12.6621 1.66675 8.75002 1.66675C4.83794 1.66675 1.66669 4.838 1.66669 8.75008C1.66669 12.6622 4.83794 15.8334 8.75002 15.8334Z"
                                stroke="#94A3B8"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M11.1071 5.97625C10.7979 5.66627 10.4305 5.42044 10.026 5.2529C9.62149 5.08536 9.18786 4.99942 8.75003 5C8.3122 4.99942 7.87857 5.08536 7.47406 5.2529C7.06955 5.42044 6.70214 5.66627 6.39294 5.97625M13.8425 13.8425L17.3779 17.3779"
                                stroke="#94A3B8"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </template>
                </v-text-field>

                <div v-for="booking in selectedBooking" class="booking-item" @click="handleChoosingBooking(booking)">
                    <div :class="{ user: true, 'is-quote': booking.just_order.is_quote }">
                        <div class="box stack-top pr-2">
                            <OrderDetailsTooltip :order="booking.just_order" :symbol-currency="$symbolCurrency">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="ppv2-text-black fw-medium rsv-client col-4" v-bind="attrs" v-on="on">
                                        {{ booking.just_order.user.first_name }} {{ booking.just_order.user.last_name }}
                                    </div>
                                </template>
                            </OrderDetailsTooltip>
                            <div
                                v-if="getTicketNbr(booking, selectedContext.event.data.prestation.id)"
                                class="details nb-ticket col-4 gap-1"
                            >
                                <span>&#128101; </span> {{ getTicketNbr(booking, selectedContext.event.data.prestation.id) }}
                                <span
                                    v-if="
                                        !['simpleticket', 'events'].includes(
                                            getPrestationTypeSlug(selectedContext.event.data.prestation)
                                        )
                                    "
                                >
                                    / {{ nbContributorTotal(selectedContext.event) }}
                                </span>
                            </div>
                            <div
                                v-if="
                                    booking.just_order.current_price != undefined && booking.just_order.total_price != undefined
                                "
                                class="details price text-white col-4"
                                :style="`background: linear-gradient(to right, #46D5B3 0%, #46D5B3 ${getPercentage(
                                    booking.just_order.current_price,
                                    booking.just_order.total_price - booking.just_order.remise_price
                                )}%, #7D2DBD ${getPercentage(
                                    booking.just_order.current_price,
                                    booking.just_order.total_price - booking.just_order.remise_price
                                )}%, #7D2DBD 100%)`"
                            >
                                <span>&#128184;</span> {{ booking.just_order.current_price }} /
                                <div class="s-price">
                                    <div class="small-original-price" v-if="booking.just_order.remise_price > 0">
                                        ({{ booking.just_order.total_price }} {{ $symbolCurrency }} )
                                    </div>
                                    <div>
                                        {{ booking.just_order.total_price - booking.just_order.remise_price }}
                                        {{ $symbolCurrency }}
                                    </div>
                                </div>
                            </div>
                            <!--  <div
                            v-if="booking.just_order.current_price != undefined && booking.just_order.total_price != undefined"
                            class="details percentage"
                        >
                            {{ getPercentage(booking.just_order.current_price, booking.just_order.total_price) }} %
                        </div>-->
                            <!-- Overlay -->
                            <div v-if="showAcceptDeclineReservation(booking)" class="overlay">
                                <div class="overlay-content">
                                    <p class="acceptation-error" v-if="acceptationError">{{ $t('planning_v3.generic_error') }}</p>
                                    <v-btn icon color="green" @click.stop="acceptReservation(booking)">
                                        <v-progress-circular
                                            v-if="acceptationLoading.accept"
                                            indeterminate
                                            size="24"
                                        ></v-progress-circular>
                                        <v-icon v-else>mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn icon color="red" @click.stop="declineReservation(booking)">
                                        <v-progress-circular
                                            v-if="acceptationLoading.decline"
                                            indeterminate
                                            size="24"
                                        ></v-progress-circular>
                                        <v-icon v-else>mdi-cancel</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="booking-item b-add-btn"
                @click="addNewContributor(selectedContext)"
                v-if="canAddNewResravation(selectedContext)"
            >
                {{ $t('planning_v3.add_reservation') }}
            </div>
            <!-- <div v-if="showAcceptDeclineReservation(booking)">
                <div class="booking-item b-add-btn" @click="declineReservation(selectedContext)">Annuler la réservation</div>

                <div class="booking-item b-add-btn" @click="acceptReservation(selectedContext)">Accepter la resérvation</div>
            </div> -->
            <slot></slot>
        </div>
        <CalendarToolBar v-on:change-page="onChangePage" :loading="loading" v-on:changePhantom="onChangePhantom">
        </CalendarToolBar>

        <div class="d-flex fixed-max-height">
            <div class="horizontal-scroll">
                <v-app class="vertical-scroll">
                    <v-overlay v-if="loading > 0" :value="true" absolute class="calendar-overlay">
                        <v-progress-circular
                            style="position: fixed; left: 50%"
                            indeterminate
                            size="64"
                            color="secondary"
                        ></v-progress-circular>
                    </v-overlay>
                    <v-sheet width="100%" :min-width="calc_calendarMinWidth" v-bind:class="{ calendarday: c_nbOfDay === 1 }">
                        <!-- Calendar- -->
                        <v-calendar
                            locale="fr"
                            ref="calendar"
                            type="category"
                            color="secondary"
                            category-show-all
                            v-model="c_dateFocus"
                            event-overlap-mode="column"
                            :columns="[]"
                            :first-time="c_firstTime"
                            :events="calc_event"
                            :categories="calc_categoriesName"
                            :interval-minutes="c_intervalMinutes"
                            :interval-count="calc_IntervalCount"
                            :interval-height="calc_IntervalHeight"
                            :category-days="c_nbOfDay"
                            @mousedown:event="onMouseDownEvent"
                            @mousedown:time-category="onMouseDownColumn"
                            @mousemove:time-category="onMouseMovColumn"
                            @mouseup:time-category="onMouseUpColumn"
                            @mousemove:time="onHoverInterval"
                            @mouseleave:time="() => (hoverTime = null)"
                        >
                            <!-- SLOT: category name -->
                            <template v-slot:category="data">
                                <div
                                    :set="
                                        (color =
                                            c_selectedCategory === data.category &&
                                            data.date === timeGetter(c_selectedTimePos, true))
                                    "
                                >
                                    <div
                                        v-if="JSON.parse(data.category).type === 'space'"
                                        class="v-calendar-category__category v-calendar-space"
                                    >
                                        <!-- <v-icon color="#b1dad6">mdi-layers</v-icon>-->
                                        <span>{{ JSON.parse(data.category).name }}</span>
                                    </div>
                                    <div v-else class="v-calendar-category__category v-calendar-staff">
                                        <v-icon color="#4b5b6b">mdi-account</v-icon>
                                        <span
                                            >{{ JSON.parse(data.category).first_name }}
                                            {{ JSON.parse(data.category).last_name }}</span
                                        >
                                    </div>
                                </div>
                            </template>

                            <template v-slot:interval="event">
                                <div
                                    style="width: 100%; height: 100%"
                                    v-bind:class="{
                                        hover_grey: hoverTime && `${event.date} ${event.time}` === timeGetterAround(hoverTime),
                                    }"
                                >
                                    <div
                                        style="width: 100%; height: 100%; text-align: center"
                                        v-bind:class="{
                                            'colored-case':
                                                c_selectedTimePos &&
                                                `${event.date} ${event.time}` === timeGetter(c_selectedTimePos),
                                            'force-color':
                                                c_showModal &&
                                                c_selectedTimePos &&
                                                `${event.date} ${event.time}` === timeGetter(c_selectedTimePos) &&
                                                calc_categoriesName.length === 0,
                                        }"
                                    >
                                        <span
                                            style="color: #8d8c8c; display: block"
                                            v-if="hoverTime && `${event.date} ${event.time}` === timeGetterAround(hoverTime)"
                                            >{{ event.time }}</span
                                        >
                                    </div>
                                </div>
                            </template>

                            <!-- SLOT: 1 day header -->
                            <template v-if="c_nbOfDay == 1" v-slot:day-label-header="{}">
                                <div></div>
                            </template>

                            <!-- SLOT: timeslots -->
                            <template v-slot:event="{ event }">
                                <CustomTimeslot :event="event"></CustomTimeslot>
                            </template>

                            <!-- SLOT: current time line -->
                            <template v-slot:day-body="{ date, week }">
                                <div
                                    class="v-current-time"
                                    :class="{ first: date === week[0].date }"
                                    :style="{ top: `${calc_currentTimePos}%`, display: calc_showCurrentTimeCursor }"
                                ></div>
                            </template>
                        </v-calendar>
                    </v-sheet>
                </v-app>
            </div>

            <!-- Modal -->
            <div
                v-if="!c_modalMobile && c_showModal"
                :class="{ 'calendar-border calendar-modal': true, 'minimized-modal': minimized, 'hide-scale': minimized }"
            >
                <div class="small-menu">
                    <v-btn
                        icon
                        class="bg-white ml-5 rounded-3 icon-rev-resp"
                        @click="
                            () => {
                                this.minimized = !this.minimized
                            }
                        "
                    >
                        <v-icon v-if="!this.minimized" class="text-black"> mdi-window-minimize</v-icon>
                        <v-icon v-else class="text-black"> mdi-window-maximize</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        class="bg-success border-0 rounded-3 icon-rev-resp"
                        @click="refreshModal = true"
                        style="background-color: green !important"
                    >
                        <v-icon class="text-white"> mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn icon class="bg-danger border-0 rounded-3 icon-rev-resp" @click="closeModal">
                        <v-icon class="text-white"> mdi-close</v-icon>
                    </v-btn>
                </div>

                <template v-if="!c_smartResa">
                    <CalendarModalAdd2
                        v-if="!c_selectedEvent || c_selectedEvent.config.draft || addNContributor"
                        v-on:hover-off="() => (disableHover = true)"
                        v-on:refresh="handledReloadCalendarTimeSlot"
                        v-on:clearSmartResa="() => (chooseAdd = null)"
                        :preSelected="preSelected"
                        :chooseAdd="chooseAdd"
                    ></CalendarModalAdd2>
                    <CalendarModalView
                        :refreshModal="refreshModal"
                        :selectAll="selectAll"
                        v-on:update-info="updateInfo"
                        v-on:select-all="changeSelectAll(true)"
                        v-on:unselect-all="changeSelectAll(false)"
                        v-on:refresh="handledReloadCalendarTimeSlot"
                        v-on:data-refreshed="
                            () => {
                                this.refreshModal = false
                            }
                        "
                        buttonColormail="#8189AD"
                        buttonColorsms="#8189AD"
                        v-else
                    ></CalendarModalView>
                </template>
                <template v-else>
                    <CalendarModalSmartResa
                        v-on:choose="chooseAddTrigger"
                        :startEsta="this.c_firstTime"
                        :endEsta="this.c_lastTime"
                    ></CalendarModalSmartResa>
                </template>
            </div>
        </div>

        <!-- Drawer -->
        <v-navigation-drawer
            v-if="c_modalMobile && c_showModal"
            right
            absolute
            permanent
            v-model="c_showModal"
            :class="{ 'calendar-border calendar-modal': true, 'minimized-modal': minimized }"
        >
            <v-app>
                <template v-if="!c_smartResa">
                    <CalendarModalAdd2
                        v-if="!c_selectedEvent || c_selectedEvent.config.draft || addNContributor"
                        v-on:hover-off="() => (disableHover = true)"
                        v-on:refresh="handledReloadCalendarTimeSlot"
                        :chooseAdd="chooseAdd"
                        :preSelected="preSelected"
                        v-on:clearSmartResa="() => (chooseAdd = null)"
                    ></CalendarModalAdd2>
                    <CalendarModalView
                        :selectAll="selectAll"
                        v-on:update-info="reloadCalendarTimeSlot"
                        v-on:select-all="changeSelectAll(true)"
                        v-on:unselect-all="changeSelectAll(false)"
                        buttonColormail="#8189AD"
                        buttonColorsms="#8189AD"
                        v-else
                    ></CalendarModalView>
                </template>
                <template v-else>
                    <CalendarModalSmartResa></CalendarModalSmartResa>
                </template>
            </v-app>
        </v-navigation-drawer>
    </v-app>
</template>
<style scoped>
.popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    padding: 10px 0;
    z-index: 2001;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    min-height: 200px;
    width: 100%;
    min-width: 280px;
    max-width: 500px;
    border-radius: 12px;
    border: 1px solid var(--Grey, #94a3b8);
}

.booking-item {
    border: 1px solid #d4d6d9;
    width: 100%;
    margin: 5px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    z-index: 10;
}

.cmd-info {
    min-width: 280px;
    max-width: 500px;
    padding: 0 10px;
    border-radius: 5px;
    font-size: clamp(12px, 0.729545vw, 16px);
    max-height: 200px;
    overflow-y: auto;
}

.rsv-client {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cmd-info::-webkit-scrollbar {
    width: 4px;
    height: 2px;
    z-index: 1;
}

.cmd-info::-webkit-scrollbar-thumb {
    background-color: #7d2dbd;
    border-radius: 5px;
    opacity: 1;
}

.cmd-info::-webkit-scrollbar-track {
    background-color: #fff;
    cursor: pointer;
}

.cmd-info .bloc {
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    padding: 4px;
    width: 100%;
    margin-bottom: 12px;
}

.bloc .b-info {
    /*flex: 33%;*/
    text-align: center;
}

.bloc .b-title {
    font-family: Poppins Regular;
    font-size: 16px;
    text-align: left;
}

.booking-item .user {
    width: 100%;
    height: 40px;
    align-items: center;
    line-height: 40px;
    overflow: hidden;
    color: var(--Navy, var(--Navy, #021832));
    font-family: Poppins Regular;
    font-size: 16px;
    position: relative;
    display: flex;
}

.user .details {
    display: flex;
    padding: 0px;
    height: 26px;
    border-radius: 4px;
    font-family: Poppins Regular;
    font-size: clamp(12px, 0.729545vw, 16px);
    margin: 0px 2px;
    position: relative;
    text-align: center;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    width: 100%;
}

.box {
    width: 100%;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
    opacity: 1;
    /* for demo purpose  */
}

.box:hover {
}

.user .box {
    width: 100%;
    opacity: 1;
}

.stack-top {
    z-index: 9;
    margin: 0;
    /* for demo purpose  */
}

.price {
    color: #000;
    /* flex: 0 0 115px; */
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nb-ticket {
    color: #fff;
    background-color: #94a3b8;
    flex: 0 0 100px;
}

.percentage {
    color: #fff;
    background-color: #000;
    flex: 0 0 74px;
}

.booking-item:hover {
    background-color: #bcdee1;
    cursor: pointer;
}

.b-modal-header {
    width: 100%;
    color: #021832;
    font-family: Poppins Regular;
    font-size: 18px;
    padding: 5px 25px 5px 0;
    margin-bottom: 18px;
    position: relative;
    border-bottom: 1px solid #f1f5f9;
}

.b-modal-header .close-btn {
    border-radius: 50%;
    cursor: pointer;
    padding: 8px 13px;
}

.b-add-btn {
    background-color: #021832;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    border: none;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
}

.b-add-btn:hover {
    background-color: #021832 !important;
    opacity: 0.7;
}

#page-container.page-header-fixed #main-container {
    padding-bottom: 5px !important;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(4, 12, 21, 0.7);
    /* semi-transparent background */
    display: none;
    justify-content: right;
    align-items: right;
    z-index: 10000;
    padding: 10px;
    border-radius: 5px;
}

.overlay-content {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    gap: 10px;
    justify-content: right;
}

.disabled-icon {
    color: grey;
    /* Adjust the color for disabled state */
}

.user:hover .overlay {
    display: flex;
    /* Show overlay on hover */
}

.is-quote {
    background-color: yellow;
}

.acceptation-error {
    color: red;
    border-radius: 7px;
    border: 2px solid red;
    font-size: 11px;
    background: white;
    display: flex;
    position: absolute;
    text-align: center;
    justify-content: center;
    left: 6px;
    height: 35px;
    top: 3px;
    align-items: center;
    padding: 6px;
}

@media screen and (max-width: 600px) {
    .popup {
        position: fixed;
        background: #fff;
        padding: 10px 0;
        z-index: 99999;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        min-height: 200px;
        min-width: 290px;
        max-width: 500px;
        border-radius: 12px;
        border: 1px solid var(--Grey, #94a3b8);
        width: 100%;
    }
}
</style>
<script>
import ApiManager from './_core/ApiManager'
import InitManager from './_core/InitManager'
import TimeSlotManager from './_core/TimeSlotManager'
import { sync, get } from 'vuex-pathify'
import qs from 'qs'
import moment from 'moment'
import ActivityManager from './_core/ActivityManager'
import introJs from 'intro.js'
const urlParams = new URLSearchParams(window.location.search)
const paramDate = moment(urlParams.get('str_date'), 'YYYY-MM-DD')
const paramSpace = urlParams.get('space_id')

export default {
    name: 'calendar-custom',

    components: {
        CalendarToolBar: () => import('./ToolBar/ToolBar.vue'),
        CustomTimeslot: () => import('./Timeslot/Timeslot.vue'),
        CalendarModalAdd2: () => import('./Modal/ModalAdd.vue'),
        CalendarModalView: () => import('./Modal/ModalView.vue'),
        CalendarModalSmartResa: () => import('./Modal/ModalSmartResa.vue'),
        OrderDetailsTooltip: () => import('./OrderDetailsTooltip.vue'),
    },

    data: () => ({
        currentWindow: {
            height: 0,
            width: 0,
        },
        hoverTime: 0,
        hoverCategory: null,
        loading: 0,
        mousePress: false,
        lockMove: true,
        disableHover: true,
        disableHoverDate: Date.now(),
        lastStaffs: null,
        lastSpaces: null,
        protectCall: false,
        protectCall2: Date.now(),
        chooseAdd: null,
        nowTime: moment(),
        nowTimeInterval: null,
        lastDateFocus: null,
        phantom: false,
        minimized: false,
        diffTime: 0,
        selectAll: false,
        moved: false,
        refreshModal: false,
        ordersData: [],
        bookingModal: false,
        selectedBooking: null,
        selectedContext: null,
        popupStyle: {
            top: '0',
            left: '0',
        },
        preSelected: {
            status: false,
            prestationID: null,
            bookingIDs: null,
            timeSlotID: null,
        },
        addNContributor: false,
        getTotalCMDDetails: { currentPrice: 0, totalPrice: 0, currentTicketsNbr: 0, totalTicketsNbr: 0 },
        acceptationLoading: {
            accept: false,
            decline: false,
        },
        showOverlay: false,
        showAcceptDeclineOptions: true,
        acceptationError: null,
    }),

    created() {
        // Replace 'paramName' with the actual parameter name
        // Replace 'paramName' with the actual parameter name

        this.c_calendar = InitManager.createInitialCalendarState()
        this.c_dateFocus = paramDate.isValid()
            ? paramDate.format('YYYY-MM-DD')
            : //    : localStorage.getItem('date-focus') || moment(new Date('2024-12-12')).format('YYYY-MM-DD')
              moment(Date.now()).format('YYYY-MM-DD')
        // == Auto resize == //
        globalThis.window.addEventListener('resize', this.handleResize)
        globalThis.window.addEventListener('mouseup', this.handleMouseUp)
        this.handleResize()

        // == Params == //
        this.c_query = !window.location.search ? {} : qs.parse(window.location.search?.replace('?', ''))
        if (this.c_query.date) this.c_dateFocus = moment(parseInt(this.c_query.date) * 1000).format('YYYY-MM-DD')
        if (this.c_query.modaladd || this.c_query.rebooking) this.c_showModal = true

        this.nowTimeInterval = setInterval(() => {
            this.nowTime = moment()
        }, 1000 * 60)
    },

    async mounted() {
        const srcElem = globalThis.document.getElementsByClassName('horizontal-scroll')[0]
        const destElem = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-body')[0]
        const destHeader = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-head')[0]
        srcElem.onscroll = () => {
            destElem.style.left = `${srcElem.scrollLeft - 1}px`
            destHeader.style.left = `${srcElem.scrollLeft - 1}px`
        }

        // == Data == //
        this.loading += 2
        await ApiManager.getStaffs()
            .then((res) => (this.c_staffs = res))
            .finally(() => (this.loading -= 1))
        await ApiManager.getSpaces()
            .then((res) => {
                this.c_spaces = res
            })
            .finally(() => (this.loading -= 1))

        const presetData = await ApiManager.getPresets()
        this.c_presets = presetData.items || []
        this.c_selectedPresetName = presetData.activePresetName || null
        // Attendre que les données soient chargées
        await this.$nextTick()

        // Appliquer le preset après le chargement des données
        let presetApplied = false
        if (this.c_selectedPresetName) {
            presetApplied = await this.applyPresetAfterLoad()
        }

        if (!presetApplied) {
            this.c_selectedSpaces = [...this.c_spaces]
        }
        if (this.c_query.date && this.c_query.timeslot) {
            await this.loadTargetedTimeslot()
        }
    },

    beforeDestroy() {
        globalThis.window.removeEventListener('resize', this.handleResize)
        globalThis.window.removeEventListener('mouseup', this.handleMouseUp)
    },

    destroyed() {
        if (this.nowTimeInterval) clearInterval(this.nowTimeInterval)
    },

    watch: {
        async c_selectedPresetName(val, oldVal) {
            // Skip on initial mount
            if (oldVal === undefined) return

            if (val === null) this.resetPreset()
            else await this.applyPreset()
        },
        async c_forceLoad(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_dateFocus(val, old) {
            if (old === undefined) return
            localStorage.setItem('date-focus', val)
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            this.hoverCategory = null
            // cancel the merge when change date
            // We can merge only the orders present in the same day
            this.c_merge_status = false
            this.c_merge_events = []
        },
        async c_nbOfDay(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_selectedStaffs(val) {
            if (this.lastStaffs === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastStaffs) {
                this.lastStaffs = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        async c_selectedSpaces(val) {
            if (this.lastSpaces === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastSpaces) {
                this.lastSpaces = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        calc_columnNbr(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) == val) {
                    srcElems[index].classList.add('selectedCategory')
                } else srcElems[index].classList.remove('selectedCategory')
            }
        },
        calc_columnNbrHover(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (this.c_selectedStaffs.length + this.c_selectedSpaces.length === 0) {
                    srcElems[index].classList.remove('selectedCategoryHover')
                } else if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) !== val) {
                    srcElems[index].classList.add('selectedCategoryHover')
                } else srcElems[index].classList.remove('selectedCategoryHover')
            }
        },

        diffTime() {
            if (this.selectAll) this.DragAllRelated()
            this.diffTime = 0
        },
        selectedBooking(val) {
            console.log('selectedBooking', val)
            this.setTotalCMDDetails()
        },
    },

    computed: {
        c_calendar: sync('calendar'),
        ...sync('calendar@data', {
            c_staffs: 'staffs',
            c_spaces: 'spaces',
            c_events: 'events',
            c_hideEvents: 'hideEvents',
            c_hideStaffs: 'hideStaffs',
            c_counterConsecColumn: 'counter',
            c_presets: 'presets',
        }),
        ...sync('calendar@params', {
            c_dateFocus: 'dateFocus',
            c_showModal: 'showModal',
            c_showModalOrderList: 'showModalOrderList',
            c_miniToolBar: 'miniToolBar',
            c_smartResa: 'smartResa',
            c_query: 'query',
            c_reopentTimeslot: 'openTimeslot',
            c_lastTime: 'lastTime',
            c_firstTime: 'firstTime',
            c_nbOfDay: 'nbOfDay',
            c_slideValueX: 'intervalXLevel',
            c_slideValueY: 'intervalYLevel',
            c_timeIntervalMinutes: 'intervalMinutes',
        }),
        ...get('calendar@params', {
            c_intervalMinutes: 'intervalMinutes',
            c_intervalYLevel: 'intervalYLevel',
            c_intervalXLevel: 'intervalXLevel',
            c_modalMobile: 'modalMobile',
            newLogin: 'newLogin',
        }),
        ...sync('calendar@selected', {
            c_selectedStaffs: 'staffs',
            c_selectedSpaces: 'spaces',
            c_forceLoad: 'load',
            c_search: 'search',
            c_selectedPresetName: 'preset',
            c_editEvents: 'editEvents',
        }),
        ...sync('calendar@selected', {
            c_selectedCategory: 'category',
            c_selectedEvent: 'event',
            c_selectedTimePos: 'mouseTime',
        }),
        ...sync('calendar@move', {
            c_move_id: 'move_id',
            c_move_start: 'move_start',
            c_move_end: 'move_end',
            c_move_event: 'move_event',
            c_move_drag: 'move_drag',
            c_duration: 'move_duration',
            c_move_date: 'move_date',
        }),
        ...sync('calendar@merge', {
            c_merge_status: 'status',
            c_merge_events: 'events',
        }),
        calc_event() {
            return !this.c_search
                ? this.c_events.filter((x) => {
                      return x.config.display ?? true
                  })
                : this.c_events.filter((x) => {
                      return (
                          x.config.block ||
                          ((x.config.display ?? true) &&
                              x.data &&
                              x.data.client &&
                              x.data.client.toLowerCase().includes(this.c_search.toLowerCase())) ||
                          (x.data &&
                              x.data.prestation &&
                              x.data.prestation.name.toLowerCase().includes(this.c_search.toLowerCase()))
                      )
                  })
        },

        calc_columnNbr() {
            if (!this.lockMove || this.disableHover || !this.c_showModal) return -1
            if (this.c_selectedCategory) {
                const index = this.calc_categoriesName.findIndex((x) => x == this.c_selectedCategory)
                return index
            }
            return -1
        },
        calc_columnNbrHover() {
            if (!this.hoverCategory) return -1
            const index = this.calc_categoriesName.findIndex((x) => x == this.hoverCategory)
            return index
        },

        // Used with intervalXLevel to expend/compact calendar width
        calc_calendarMinWidth() {
            let counter = 0
            for (const key in this.c_counterConsecColumn) {
                counter += this.c_counterConsecColumn[key] + 1
            }

            //  return `${Math.floor(counter * 50 + Math.floor((counter * 50 * this.c_intervalXLevel) / 3))}px`
            return `${Math.floor(100 + Math.floor(100 * this.c_intervalXLevel))}%`
        },

        // Used with c_intervalYLevel to expend/compact height cell
        calc_IntervalHeight() {
            return `${
                (this.currentWindow.height - 280) / this.calc_IntervalCount +
                5 * ((this.c_intervalYLevel > 5 ? this.c_intervalYLevel * 4 : this.c_intervalYLevel) * 2)
            }px`
        },

        // Compute minutes between interval [first time <-> last time]
        calc_calendarDayMinutes() {
            const start = moment(this.c_firstTime, 'hh:mm')
            const end = moment(this.c_lastTime, 'hh:mm')
            return moment.duration(end.diff(start)).asMinutes()
        },

        // Compute the nb of needed interval
        calc_IntervalCount() {
            return this.calc_calendarDayMinutes / this.c_intervalMinutes + 1
        },

        // Generate all calendar column name's
        calc_categoriesName() {
            return this.c_selectedStaffs
                .filter(
                    (x) =>
                        !this.c_hideStaffs.find((y) => y.id === x.id && y.count === 0 && !x.tmp) ||
                        this.c_events.find((e) => !e.config.block && e.category === x.stringify)
                )
                .map((x) => x.stringify)
                .concat(this.c_selectedSpaces.map((x) => x.stringify))
        },

        // Used to display current time curssor
        calc_currentTimePos() {
            const start = moment(this.c_firstTime, 'hh:mm')
            const now = this.nowTime
            const tt = this.calc_calendarDayMinutes
            return (moment.duration(now.diff(start)).asMinutes() * 100) / tt
        },

        // Is today ?
        calc_showCurrentTimeCursor() {
            return this.c_dateFocus === moment().format('YYYY-MM-DD') ? 'relative' : 'none'
        },
    },

    methods: {
        async applyPresetAfterLoad() {
            // Attendre un peu pour être sûr que les données sont chargées
            await new Promise((resolve) => setTimeout(resolve, 100))

            const preset = this.c_presets.find((p) => p.name === this.c_selectedPresetName)
            if (!preset) return false

            // Appliquer le preset
            await this.$store.dispatch('applyPreset', {
                preset: preset,
                updateSelections: true,
            })

            // Forcer un rechargement
            await this.reloadCalendarTimeSlot()
            return true
        },
        async applyPresetFromName(presetName) {
            const preset = this.c_presets.find((p) => p.name === presetName)
            if (!preset) return

            // Appliquer via l'action Vuex
            await this.$store.dispatch('calendar/applyPreset', {
                preset: preset,
                updateSelections: true,
            })

            // Forcer le rechargement
            await this.reloadCalendarTimeSlot()
        },
        closeModal() {
            this.c_showModal = false
            this.c_move_event = []
        },
        canAddNewResravation(context) {
            let res
            switch (this.getPrestationTypeSlug(context.event.data.prestation)) {
                case 'vr':
                    res = false
                    break
                case 'events':
                    res = context.event.data.info.nb_contributor < context.event.data.prestation.type
                    break
                case 'simpleticket':
                    res = context.event.data.info.nb_contributor < context.event.data.info.space.capacity
                    break
                case 'paintball':
                    res =
                        context.event.data.info.nb_contributor <
                            Math.min(
                                context.event.data.info.space.capacity,
                                context.event.data.prestation.max_contributors ?? 0
                            ) &&
                        (context.event.data.info.enableMixing ?? true)
                default:
                    res =
                        context.event.data.info.nb_contributor <
                        Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0)
                    break
            }
            return res
            // if (this.getPrestationTypeSlug(context.event.data.prestation) == 'events')
            //     return context.event.data.info.nb_contributor < context.event.data.prestation.type
            // else if (typeof context.event.data.info.enableMixing === 'undefined' || context.event.data.info.enableMixing === null)
            //     return (
            //         context.event.data.info.nb_contributor <
            //         Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0)
            //     )
            // else
            //     return (
            //         context.event.data.info.nb_contributor <
            //             Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0) &&
            //         context.event.data.info.enableMixing
            //     )
        },
        addNewContributor(context) {
            // console.log('contextcontextcontext', context)

            this.preSelected.prestationID = context.event.data.prestation.id
            this.preSelected.status = true
            this.preSelected.bookingIDs = context.event.bookings.map((x) => x.id)
            this.preSelected.timeSlotID = context.event.bookings[0].pivot.id_time_slot
            this.addNContributor = true
            this.c_showModal = true
            this.c_smartResa = false
            this.bookingModal = false
        },

        updateInfo() {
            this.c_move_event = []
            this.c_move_staff = {}
            this.changeSelectAll(false)
            this.reloadCalendarTimeSlot()
        },
        refreshAutoSizeColumn() {
            // headers
            {
                const res = document.querySelector('.v-calendar-daily_head-day .v-calendar-category__columns')
                if (!res) return

                res.children.forEach((element, index) => {
                    const target = this.calc_categoriesName[index]
                    if (!target) return

                    const flex = this.c_counterConsecColumn[target]
                    if (!flex) return

                    //   element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
                })
            }

            // body
            {
                const res = document.querySelector('.v-calendar-daily__day-container')
                if (!res) return

                res.children.forEach((element, index) => {
                    if (index === 0) return

                    const target = this.calc_categoriesName[index - 1]
                    if (!target) return

                    const flex = this.c_counterConsecColumn[target]
                    if (!flex) return

                    // element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
                })
            }
        },

        timeGetter(date, onlyDate = false) {
            return moment(date).format(onlyDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')
        },

        getPrestationTypeSlug(prestat) {
            return prestat.subCategory.slug.toLowerCase()
        },

        chooseAddTrigger(params) {
            this.chooseAdd = params
            this.c_selectedEvent = null
            this.c_smartResa = false
            this.c_showModal = true
        },

        timeGetterAround(date) {
            const obj = moment(date)
            return obj.add(-date.minutes() % this.c_intervalMinutes, 'minutes').format('YYYY-MM-DD HH:mm')
        },

        isTmp(cat) {
            if (cat.type === 'staff') {
                return this.c_selectedStaffs.find((x) => x.id === cat.id && x.tmp) != null
            } else {
                return this.c_selectedSpaces.find((x) => x.id === cat.id && x.tmp) != null
            }
        },

        async handledReloadCalendarTimeSlot() {
            this.preSelected.status = false
            this.addNContributor = false
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },

        handleResize() {
            this.currentWindow.height = globalThis.window.innerHeight
            this.currentWindow.width = globalThis.window.innerWidth
            if (this.currentWindow.width < 958 && !this.c_miniToolBar) this.c_miniToolBar = true
            if (this.currentWindow.width >= 958 && this.c_miniToolBar) this.c_miniToolBar = false
        },

        handleMouseUp() {
            this.lockMove = true
        },
        changeSelectAll(value) {
            this.selectAll = value
            value
                ? this.c_events.forEach((z) => {
                      if (z.id == this.c_selectedEvent.id) z.config.movable = true
                  })
                : this.handledReloadCalendarTimeSlot()
        },
        // == Events == //
        async onChangePage(next) {
            if (next) this.$refs.calendar.next()
            else this.$refs.calendar.prev()
        },
        async onChangePhantom(dataphantom) {
            this.phantom = true
            this.reloadCalendarTimeSlot()
        },

        onHoverInterval(context) {
            this.hoverTime = moment(`${context.date} ${context.time}:00`)
        },

        // Click on timeslot
        onMouseDownEvent(context, event) {
            this.bookingModal = false

            const x = event.clientX // X-coordinate of the cursor
            const y = event.clientY // Y-coordinate of the cursor

            // Do something with the cursor coordinates (x, y)
            this.popupStyle.left = '50%'
            this.popupStyle.top = '50%'
            this.popupStyle.transform = 'translate(-50%,-50%)'
            this.selectedBooking = null

            if (context.event.bookings && context.event.bookings.length > 0) {
                if (
                    context.event.bookings.length == 1 &&
                    context.event.data.info.nb_contributor == context.event.data.info.space.capacity
                )
                    return this.onMouseDownAfterChoosingEvent(context)
                this.bookingModal = true
                this.selectedBooking = context.event.bookings
                this.selectedContext = context
                return
            }
            this.onMouseDownAfterChoosingEvent(context)
        },
        handleChoosingBooking(booking) {
            let selectedEv = this.c_events.find((x) => x.data.bookingId == booking.id)
            this.selectedContext.event = selectedEv
            this.bookingModal = false
            this.onMouseDownAfterChoosingEvent(this.selectedContext)
        },
        onMouseDownAfterChoosingEvent(context) {
            if (!context.event.config.draft && this.c_events.find((x) => x.config.draft)) return
            if (context.event.category && !context.event.config.draft) {
                const wanted = JSON.parse(context.event.category)
                if (this.c_selectedSpaces.findIndex((y) => y.id == wanted.id) == -1) {
                    this.c_selectedSpaces.push(this.c_spaces.find((y) => y.id == wanted.id))
                }
                const target =
                    this.c_selectedSpaces.find((y) => y.id == wanted.id) || this.c_selectedStaffs.find((y) => y.id == wanted.id)

                if (target && target.tmp) target.tmp = false
            }
            this.c_showModal = true

            this.c_selectedEvent = context.event
            this.disableHover = true
            // Secure time
            this.disableHoverDate = Date.now() + 500

            // Merge orders
            if (this.c_merge_status) {
                const check = this.c_merge_events.find((x) => x.order_id == context.event.data.order_id)
                // Check if the item not already added to the merege list and doesn't closed (status = 7 in the DB)
                // Please not in front-end we are using the value 6 for closed CMD.
                if (!check && context.event.data.status != 6) {
                    let duplicates = {}
                    let relatedItems = Object.create(
                        this.c_events
                            .filter((x) => {
                                return x.data.order_id == context.event.data.order_id
                            })
                            .filter((item) => {
                                if (!duplicates[item.id]) {
                                    duplicates[item.id] = true
                                    return true
                                }
                                return false
                            })
                    )
                    relatedItems.sort((x, y) => x.start - y.start)
                    this.c_merge_events[1] = {
                        order_id: context.event.data.order_id,
                        booking_id: context.event.data.bookingId,
                        name: context.event.data.prestation.name,
                        timeslot_id: context.event.data.id,
                        client: context.event.data.client,
                        relatedItems: relatedItems,
                    }
                }
            }
        },

        // Click on category
        onMouseDownColumn(context) {
            this.addNContributor = false
            this.preSelected.status = false
            if (this.bookingModal) return
            if (
                this.c_selectedEvent &&
                this.c_selectedEvent.config.block &&
                this.c_selectedEvent.data &&
                this.c_selectedEvent.data.priority !== 3 &&
                !this.c_selectedEvent.data.lunch
            ) {
                this.c_selectedEvent = null
                this.c_showModal = false
                return
            }
            this.selectedBooking = null
            this.c_selectedCategory = context.category
            this.c_showModal = true
            this.c_smartResa = false
            this.lockMove = false
            if (this.disableHoverDate < Date.now()) {
                this.disableHover = false
                this.c_selectedEvent = null
            }

            let cursorStart = moment(`${context.date} ${context.time}:00`)
            const remainder = -(cursorStart.minute() % this.c_intervalMinutes)
            cursorStart = cursorStart.add(remainder, 'minutes').valueOf()

            this.c_selectedTimePos = cursorStart
        },
        getPercentage(current, total) {
            if (total == 0) return 100
            let per = (current / total) * 100
            return per.toFixed(2)
        },
        onMouseMovColumn(context) {
            if (this.c_selectedEvent?.config.movable && this.c_move_drag) {
                const eventDate = new Date(this.c_selectedEvent.start)
                const mouseTime = new Date(eventDate.toDateString() + ' ' + context.time).getTime()
                let diff = 0
                if (mouseTime - this.c_selectedEvent.start >= 300000) {
                    this.moveReal(context, this.c_selectedEvent.start, mouseTime)
                    let allEvent = this.c_events.filter(
                        (ev) =>
                            ev.data.order_id == this.c_selectedEvent.data.order_id &&
                            ev.id != this.c_selectedEvent.id &&
                            ev.start > this.c_selectedEvent.start
                    )
                    // console.log('allEvent',allEvent)
                    allEvent.length > 0
                    {
                        let previous = allEvent[0]
                        let changed = false
                        if (this.c_selectedEvent.end >= allEvent[0].start) {
                            this.moved = true

                            allEvent.forEach((e, index) => {
                                if (allEvent[index].id != previous.id) {
                                    previous = allEvent[index - 1]
                                    changed = true
                                }
                                const diff = e.end - e.start
                                changed && e.id != allEvent[0].id
                                    ? (e.start = previous.end)
                                    : (e.start = this.c_selectedEvent.end)
                                e.end = e.start + diff
                            })
                        } else {
                            if (this.moved)
                                allEvent.forEach((e, index) => {
                                    if (allEvent[index].id != previous.id) {
                                        previous = allEvent[index - 1]
                                        changed = true
                                    }
                                    const diff = e.end - e.start
                                    changed && e.id != allEvent[0].id
                                        ? (e.start = previous.end)
                                        : (e.start = this.c_selectedEvent.end)
                                    e.end = e.start + diff
                                })
                        }
                    }
                }
            } else {
                this.hoverCategory = context.category
                if (this.lockMove || !this.c_selectedEvent || !this.c_selectedEvent.config.movable) return

                let collision = null
                let leave = false
                const newDate = moment(`${context.date} ${context.time}:00`).add(-10, 'minutes')
                newDate.add(-newDate.minutes() % 5, 'minutes')
                let newStart = newDate.valueOf()
                let newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)

                const parent = this.c_selectedEvent.parent ? this.c_selectedEvent.parent : this.c_selectedEvent
                if (
                    this.c_selectedEvent.config.draft &&
                    !this.c_selectedEvent.isIndispo &&
                    context.category != this.c_selectedEvent.category &&
                    this.c_nbOfDay === 1
                ) {
                    const contextCat = JSON.parse(context.category)
                    const eventCat = JSON.parse(this.c_selectedEvent.category)
                    if (contextCat.type != eventCat.type) return

                    if (!parent.list.find((x) => x.category === context.category)) {
                        if (contextCat.type === 'staff') {
                            parent.ref_presta.selectedPracticienne = parent.ref_presta.selectedPracticienne.filter(
                                (x) => x.id !== eventCat.id
                            )
                            parent.ref_presta.selectedPracticienne.push(contextCat)
                        } else {
                            parent.ref_presta.selectedSpace = contextCat
                        }
                        this.c_selectedEvent.category = context.category
                    }
                }

                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return

                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                collision = y
                            }
                        })
                })

                if (collision && !this.c_selectedEvent.isIndispo) {
                    if (newStart - collision.start < collision.end - newStart) {
                        // TP en haut
                        newStart = collision.start - (this.c_selectedEvent.end - this.c_selectedEvent.start)
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    } else {
                        // Tp en bas
                        newStart = collision.end
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    }
                }

                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return
                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                leave = true
                            }
                        })
                })
                if (leave) return

                // Real Cards
                if (!this.c_selectedEvent.config.draft && !this.c_selectedEvent.config.block) {
                    this.moveReal(context, newStart, newEnd)
                    return
                }

                if (this.c_selectedEvent.config.block) {
                    Object.assign(parent, {
                        start: newStart,
                        end: newEnd,
                    })
                    return
                }

                // Draft Cards
                Object.assign(parent.ref_presta, {
                    start: newStart,
                    end: newEnd,
                })
                Object.assign(parent, {
                    start: newStart,
                    end: newEnd,
                })
                parent.list.forEach((l) => {
                    Object.assign(l, {
                        start: newStart,
                        end: newEnd,
                    })
                })
            }
        },

        onMouseUpColumn(context) {
            this.c_move_drag = false
            this.moved = false
        },

        moveReal(context, newStart, newEnd) {
            /** All event timeslots have the same Id.
             *  The idea we need to know the drag (with time ms).
             *  I used the @take to save only the first diff
             */
            let take = true
            //  let relatedTimeslots = this.c_events.filter((x) => )
            this.c_events.forEach((e, index) => {
                if (e.id == this.c_selectedEvent.id) {
                    if (take) {
                        this.diffTime = newStart - e.start
                        take = false
                    }
                    e.start = newStart
                    e.end = newEnd
                    this.c_duration.push({ id: this.c_selectedEvent.id, value: Math.floor((newEnd - newStart) / 1000 / 60) })
                }
            })
        },
        DragAllRelated() {
            // take all related events (timeslot) without the current one.
            let allEvent = this.c_events.filter(
                (ev) => ev.data.order_id == this.c_selectedEvent.data.order_id && ev.id != this.c_selectedEvent.id
            )
            allEvent.forEach((e) => {
                e.start += this.diffTime
                e.end += this.diffTime
            })
        },

        // == Data == //
        async reloadCalendarTimeSlot() {
            // Init
            // console.log("this.c_events", this.c_events);
            const requestDate = Date.now()
            const days = this.getTargetDays()
            const staff_ids = this.c_selectedStaffs.map((x) => x.id) || []
            const space_ids = this.c_selectedSpaces.map((x) => x.id) || []
            const phantom = this.phantom
            // Load data
            const [timeslot, working, schedule] = await Promise.all([
                ApiManager.getAllTimeslotPack(days, staff_ids, space_ids, phantom),
                ApiManager.loadWorkingTime(staff_ids, space_ids, days),
                ApiManager.getEstaInfoForDays(days).catch((err) => console.log('Error:', err)),
            ])

            if (requestDate < this.protectCall2) return
            this.protectCall2 = requestDate
            // console.log("this.c_events 2", this.c_events);

            // Reset all events
            this.c_events = TimeSlotManager.resetNoDraft(this.c_events)
            //  console.log("this.c_events 3", this.c_events);
            if (this.c_move_event) {
                this.c_move_event = TimeSlotManager.deleteDuplicate(this.c_move_event, 'category', 'data', 'id')
                this.c_move_event.forEach((element) => {
                    /**
                     * This condition used to check if this element is already in calender (Current day) or not
                     * Create a couple ids between the item_id and the sttaff id
                     */
                    let condition = this.c_events
                        .map((x) => x.data.id + '-' + JSON.parse(x.category).id)
                        .includes(element.data.id + '-' + JSON.parse(element.category).id)
                    element.data.info.colorCategory = '#ff0000'
                    // console.log('element',element)
                    element.config.display = true

                    if (!condition) this.c_events.push(element)
                })
            }
            // Get calendar time
            const { start, end } = this._getBestCalendarTime(schedule, timeslot)
            this.c_firstTime = start
            this.c_lastTime = end

            // Generate blocks before and after establishement time
            this._generateScheduleBlocs(schedule)

            if (working) {
                // Generate indispo
                this._generateIndispoBlocs(working)

                // Generate blocks before and after working time
                const done = this._generateWorkingBlocs(working)
                // Generate exception block
                this._generateExceptionBlocs(working)
                if (true) {
                    const hideEmptyColumn = this._generateMissingWorkingBlocs(days, done)
                    this.c_hideStaffs = hideEmptyColumn
                } else {
                    this.closeEmptyPlaning(days)
                }
            }
            this.c_events = TimeSlotManager.mergeBlock(this.c_events)

            //
            // insert real timeslot
            const assoc = {}
            timeslot.forEach((day) => {
                console.log('day', day)
                for (const data of day.spaces) {
                    const target = this.c_spaces.find((x) => x.id == data.id)
                    if (target)
                        TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc, day)
                }
                for (const data of day.staffs) {
                    const target = this.c_staffs.find((x) => x.id == data.id)
                    if (target)
                        TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc, day)
                }
            })

            this.c_events = TimeSlotManager.mergeBlock(this.c_events, true)

            // Choose each column size
            this.c_counterConsecColumn = TimeSlotManager.computedMaxBlock(this.c_events)
            this.refreshAutoSizeColumn()
            if (this.c_move_event.length > 0) {
                this.c_selectedEvent = this.c_events.find((x) => x.data.bookingId === this.c_move_event[0].data.bookingId)
            }
            // refresh opened timeslot ?
            if (this.c_reopentTimeslot) {
                this.c_selectedEvent = this.c_events.find((x) => x.data.bookingId === this.c_reopentTimeslot)
                this.c_reopentTimeslot = null
                await this.handledReloadCalendarTimeSlot()
            }
        },
        minutesToTime(minutes) {
            const hours = Math.floor(minutes / 60)
                .toString()
                .padStart(2, '0')
            const mins = (minutes % 60).toString().padStart(2, '0')
            return `${hours}:${mins}`
        },
        timeToMinutes(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number)
            return hours * 60 + minutes
        },
        _getBestCalendarTime(schedule, timeSlots) {
            let timeSlotsCopy = timeSlots
                .map((x) => x.spaces.map((b) => b.timeslots.map((c) => c.timeslot)).flat())
                .flat()
                .map((d) => ({
                    start:
                        moment(d.start * 1000).format('HH:mm') < moment(d.end * 1000).format('HH:mm')
                            ? moment(d.start * 1000).format('HH:mm')
                            : moment(d.end * 1000).format('HH:mm'),
                    end:
                        moment(d.end * 1000).format('HH:mm') > moment(d.start * 1000).format('HH:mm')
                            ? moment(d.end * 1000).format('HH:mm')
                            : moment(d.start * 1000).format('HH:mm'),
                }))

            let scheduleCopy = schedule.map((x) => ({
                start: x.start,
                end: x.end,
            }))

            let mergedArray = [...timeSlotsCopy, ...scheduleCopy]

            // const interval = mergedArray.reduce(
            //     (acc, currentValue) => {
            //         return {
            //             minStart: acc.start < currentValue.start ? acc.start : currentValue.start,
            //             maxEnd: acc.end > currentValue.end ? acc.end : currentValue.end,
            //         }
            //     },
            //     { minStart: null, maxEnd: null }
            // )

            // Find the minimum start time
            const minStartTime = mergedArray
                .map((item) => this.timeToMinutes(item.start)) // Convert start times to minutes
                .reduce((min, current) => Math.min(min, current), Infinity) // Find the minimum

            // Find the maximum end time
            const maxEndTime = mergedArray
                .map((item) => this.timeToMinutes(item.end)) // Convert end times to minutes
                .reduce((max, current) => Math.max(max, current), -Infinity) // Find the maximum

            // Convert minutes back to time strings
            const minStartTimeStr = this.minutesToTime(minStartTime)
            const maxEndTimeStr = this.minutesToTime(maxEndTime)

            const interval = { minStart: minStartTimeStr, maxEnd: maxEndTimeStr }
            // oversize
            //console.log('interval', interval)

            return {
                start: moment(interval.minStart || '07:00', 'HH:mm')
                    // .subtract({
                    //     minutes: this.c_intervalMinutes,
                    // })
                    .format('HH:mm'),
                end: moment(interval.maxEnd || '18:00', 'HH:mm')
                    // .add({
                    //     minutes: this.c_intervalMinutes,
                    // })
                    .format('HH:mm'),
            }
        },

        _generateScheduleBlocs(res) {
            res.forEach((d) => {
                const day = moment(d.date * 1000).format('YYYY-MM-DD')
                const insert = (cat, d1, d2) => {
                    TimeSlotManager.addEstablishmentBlock(
                        this.c_events,
                        moment(d1, 'YYYY-MM-DD HH:mm').valueOf(),
                        moment(d2, 'YYYY-MM-DD HH:mm').valueOf(),
                        cat.stringify
                    )
                }
                this.c_selectedStaffs.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.lunch_start}`, `${day} ${d.lunch_end}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
                this.c_selectedSpaces.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.lunch_start}`, `${day} ${d.lunch_end}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
            })
        },

        _generateIndispoBlocs(workingTime) {
            const insert = (start, end, cat, id, name, text, recId, rec, status, text_exception) => {
                TimeSlotManager.addIndispoBlock(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    id,
                    name,
                    text,
                    recId,
                    rec,
                    status,
                    text_exception
                )
            }
            if (workingTime.planning.length > 0)
                workingTime.planningsException.forEach((h) =>
                    insert(
                        `${h.start}`,
                        `${h.end}`,
                        this.c_staffs.find((x) => x.id == h.user_id).stringify,
                        h.id,
                        'staff',
                        h.text,
                        h.recurence_id,
                        h.rec,
                        h.status,
                        h.nature_type
                    )
                )
            workingTime.planningsExceptionSpace.forEach((h) =>
                insert(
                    `${h.start}`,
                    `${h.end}`,
                    this.c_spaces.find((x) => x.id == h.space_id).stringify,
                    h.id,
                    'space',
                    h.text,
                    h.recurence_id,
                    h.rec
                )
            )
        },

        closeEmptyPlaning(days) {},

        _generateWorkingBlocs(workingTime) {
            let done = {}
            const insert = (start, end, cat, launch, id) => {
                TimeSlotManager.addWorkingTime(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    launch,
                    id
                )
            }

            workingTime.planning.staffs.forEach((h) => {
                const date = moment.utc(h.date, 'YYYY-MM-DD').valueOf() / 1000
                if (!done[date]) done[date] = {}
                if (done[date] && !done[date][h.user_id]) done[date][h.user_id] = true

                // start - morning block
                insert(`${h.date} 00:00:00`, `${h.date} ${h.start}`, this.c_staffs.find((x) => x.id == h.user_id).stringify)

                // launch block
                if (`${h.date} ${h.lunch_start}` !== `${h.date} ${h.lunch_end}`) {
                    insert(
                        `${h.date} ${h.lunch_start}`,
                        `${h.date} ${h.lunch_end}`,
                        this.c_staffs.find((x) => x.id == h.user_id).stringify,
                        true,
                        h.id
                    )
                }

                // end - afternoon block
                insert(`${h.date} ${h.end}`, `${h.date} 23:59:59`, this.c_staffs.find((x) => x.id == h.user_id).stringify)
            })

            workingTime.planning.spaces.forEach((h) => {
                const date = moment.utc(h.date, 'YYYY-MM-DD').valueOf() / 1000
                if (!done[date]) done[date] = {}
                if (done[date] && !done[date][h.space_id]) done[date][h.space_id] = true

                // start - morning block
                if (h.space_id)
                    insert(`${h.date} 00:00:00`, `${h.date} ${h.start}`, this.c_spaces.find((x) => x.id == h.space_id).stringify)

                // launch block
                if (`${h.date} ${h.lunch_start}` !== `${h.date} ${h.lunch_end}` && h.lunch_start && h.lunch_end) {
                    insert(
                        `${h.date} ${h.lunch_start}`,
                        `${h.date} ${h.lunch_end}`,
                        this.c_spaces.find((x) => x.id == h.space_id).stringify,
                        true,
                        h.id
                    )
                }

                // end - afternoon block
                if (h.space_id)
                    insert(`${h.date} ${h.end}`, `${h.date} 23:59:59`, this.c_spaces.find((x) => x.id == h.space_id).stringify)
            })
            return done
        },

        _generateExceptionBlocs(workingTime) {
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            workingTime.planningsEstablishement.forEach((h) => {
                this.c_selectedStaffs.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(
                        this.c_events,
                        getDate(`${h.start}`),
                        getDate(`${h.end}`),
                        x.stringify
                    )
                })
                this.c_selectedSpaces.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(
                        this.c_events,
                        getDate(`${h.start}`),
                        getDate(`${h.end}`),
                        x.stringify
                    )
                })
            })
        },

        _generateMissingWorkingBlocs(days, done) {
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            const hide = []
            days.forEach((d) => {
                this.c_selectedStaffs.forEach((s) => {
                    if (!done[d] || !done[d][s.id]) {
                        TimeSlotManager.addWorkingTime(
                            this.c_events,
                            getDate(`${moment(d * 1000).format('YYYY-MM-DD')} 00:00:00`),
                            getDate(`${moment(d * 1000).format('YYYY-MM-DD')} 23:59:59`),
                            this.c_staffs.find((x) => x.id == s.id).stringify
                        )
                        const target = hide.find((h) => h.id === s.id)
                        if (target) target.count -= 1
                        else
                            hide.push({
                                id: s.id,
                                count: days.length - 1,
                            })
                    }
                })
            })
            return hide
        },
        // == //

        // == Utils == //
        getTargetDays() {
            const targetsDays = []
            for (let i = 0; i < this.c_nbOfDay; i++)
                targetsDays.push(
                    moment
                        .utc(this.c_dateFocus)
                        .utcOffset(0)
                        .set({
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                        })
                        .add(i, 'days')
                        .valueOf() / 1000
                )
            return targetsDays
        },

        // == Preset == //
        async applyPreset() {
            const target = this.c_presets.find((x) => x.name == this.c_selectedPresetName)
            if (!target) return
            // [staff]
            const newStaffs = []
            target.config.staffs.forEach((s) => {
                const wanted = this.c_staffs.find((x) => x.id === s)
                if (wanted) newStaffs.push(wanted)
                else console.warn(`[preset] - staff not found ${s}`)
            })
            // [space]
            const newSpaces = []
            if (paramSpace) {
                const Pspace = this.c_spaces.find((x) => x.id == paramSpace)
                if (Pspace && target.config.spaces.findIndex((x) => x == paramSpace) == -1) {
                    newSpaces.push(Pspace)
                }
            }
            target.config.spaces.forEach((s) => {
                const wanted = this.c_spaces.find((x) => x.id === s)
                if (wanted) newSpaces.push(wanted)
                else console.warn(`[preset] - space not found ${s}`)
            })
            // [Assign]
            this.c_selectedStaffs = newStaffs
            this.c_selectedSpaces = newSpaces
            this.c_nbOfDay = target.config.nbOfDay
            this.c_slideValueX = target.config.slideValueX
            this.c_newLogin = target.config.newLogin
            this.c_slideValueY = target.config.slideValueY
            this.c_timeIntervalMinutes = parseInt(target.config.timeIntervalMinutes)
        },

        resetPreset() {
            this.c_selectedStaffs = []
            this.c_selectedSpaces = []
            this.c_nbOfDay = 1
            this.c_slideValueX = 0
            this.c_newLogin = false
            this.c_slideValueY = 4
            this.c_timeIntervalMinutes = 30
        },

        async loadTargetedTimeslot() {
            await ApiManager.getTimeslotInfo(parseInt(this.c_query.timeslot)).then(async (res) => {
                const timeslot = await ApiManager.getAllTimeSlotOfBooking(res.booking.id)

                timeslot.forEach((t) => {
                    t.staff.forEach((s) => {
                        if (!this.c_selectedStaffs.find((x) => x.id == s.id)) {
                            const target = this.c_staffs.find((x) => x.id == s.id)
                            if (target) {
                                target.tmp = true
                                this.c_selectedStaffs.push(target)
                            }
                        }
                    })

                    if (!this.c_selectedSpaces.find((x) => x.id == t.timeslot[0].space.id)) {
                        const target = this.c_spaces.find((x) => x.id == t.timeslot[0].space.id)
                        if (target) {
                            target.tmp = true
                            this.c_selectedSpaces.push(target)
                        }
                    }
                })
                const event = this.c_events.find((x) => x.id === `slot-${this.c_query.timeslot}`)
                if (event) {
                    this.c_selectedEvent = event
                    this.c_showModal = true
                }
            })
        },
        getTicketNbr(booking, prestation_id) {
            return ActivityManager.getTicketNbr(booking, prestation_id)
        },

        nbContributorTotal(event) {
            return event.data.info.nb_contributor
        },
        setTotalCMDDetails() {
            this.getTotalCMDDetails = ActivityManager.getTotalCMDDetails(this.selectedContext.event)
            console.log(' this.getTotalCMDDetails', this.getTotalCMDDetails)
        },
        startIntro() {
            introJs()
                .setOptions({
                    showBullets: false,
                    doneLabel: 'Compris',
                    steps: [
                        {
                            element: document.querySelector('#reservations_intro'),
                            intro: "Cette fenêtre vous permet de voir les réservations associées à ce créneau, de consulter le nombre de personnes par rapport à la capacité maximale, de vérifier le montant payé par rapport au montant attendu et d'afficher le nom et le prénom du réservant .",
                        },
                    ],
                })
                .start()
        },
        showAcceptDeclineReservation(booking) {
            // let isTemporary = false
            // console.log('bookingsss', bookings)
            // bookings.forEach((booking) => {
            //     if (booking.status == -7) {
            //         isTemporary = true
            //     }
            // })
            // return isTemporary
            return booking.status == -7
        },
        acceptAllRelatedReservations(context) {
            //console.log('acceptReservation', context, this.event)
            this.acceptationLoading.accept = true
            let timeslotId = context.event.id.split('-')[1]
            ApiManager.acceptAllRelatedReservations(timeslotId)
                .then((data) => {
                    this.acceptationLoading.accept = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },

        acceptReservation(booking) {
            // console.log('acceptReservation', booking)
            this.acceptationLoading.accept = true

            ApiManager.acceptReservation(booking.id)
                .then((data) => {
                    this.acceptationLoading.accept = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },

        declineAllRelatedReservations(context) {
            // console.log('acceptReservation', context, this.event)
            this.acceptationLoading.decline = true

            let timeslotId = context.event.id.split('-')[1]
            ApiManager.declineAllRelatedReservations(timeslotId)
                .then((data) => {
                    this.acceptationLoading.decline = false
                    this.showAcceptDeclineOptions = false
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },
        declineReservation(booking) {
            // console.log('acceptReservation', booking)
            this.acceptationLoading.decline = true

            ApiManager.declineReservation(booking.id)
                .then((data) => {
                    this.acceptationLoading.decline = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },
    },
}
</script>

<style scoped>
@import './_style/Calendar.css';
</style>

<style lang="scss">
.v-event-timed {
    border-radius: 0px !important;
}

.v-calendar-category .v-calendar-daily__day,
.v-calendar-category .v-calendar-category__column {
    min-width: 220px !important;
}

.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
    min-width: 220px !important;
    margin-top: -0.04%;
}

.v-calendar-daily__day-container .v-calendar-daily__day:nth-child(2) {
    .v-current-time {
        &.first::before {
            content: '';
            position: absolute;
            background-color: #7d2dbd;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-top: -5px;
            margin-left: -6.5px;
            z-index: 10;
        }
    }
}

.v-current-time {
    height: 2px;
    background-color: #7d2dbd;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
    z-index: 12;
}

.v-event-timed-container {
    margin-right: 0px !important;
}

.theme--light.v-calendar-events .v-event-timed {
    border: none !important;
}

.v-calendar-category .v-calendar-daily__head {
    z-index: 15 !important;
    height: 43px;
}

.v-calendar-staff {
    color: #4b5b6b;
}

.v-calendar-space {
    color: #94a3b8;
    font-family: Poppins Regular;
    font-size: 12px;
}
</style>
<style scoped>
.original-price {
    text-decoration: line-through;
    color: red;
}

.small-original-price {
    font-size: 10px;
    text-decoration: line-through;
    color: red;
}

.s-price {
    display: flex;
}

.vapp {
    margin: 0 !important;
}
</style>
